"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var L = require("leaflet");
var TxSimpleMapComponent = /** @class */ (function () {
    function TxSimpleMapComponent(elRef) {
        var _this = this;
        this.elRef = elRef;
        this.mapId = Date.now();
        this.originalLat = -3.753092453196685;
        this.originalLng = -38.52390289306641;
        this.originalZoom = 15;
        this.lat = this.originalLat;
        this.lng = this.originalLng;
        this.zoom = this.originalZoom;
        this.id = 'mapbox.streets';
        this.MAP_URL = 'https://api.tiles.mapbox.com/v4/{id}/{z}/{x}/{y}.png?access_token={accessToken}';
        this.accessToken = 'pk.eyJ1IjoiZ3VzdGF2b2FpcmVzIiwiYSI6ImNqNGhyanNsaDAxbTYyd3M2cGhicndzcDYifQ.gN__JIYsdSHdDCQ0scIo8g';
        this.attribution = "Map data &copy; <a href=\"http://openstreetmap.org\">OpenStreetMap</a>\n                contributors, <a href=\"http://creativecommons.org/licenses/by-sa/2.0/\">CC-BY-SA</a>,\n                Imagery \u00A9 <a href=\"http://mapbox.com\">Mapbox</a>";
        this.icon = null;
        this.options = {};
        this.setMapMarker = function (file) {
            if (!_this.icon) {
                _this.icon = new L.Icon({
                    iconUrl: file,
                    iconAnchor: [13, 43]
                });
                _this.options = { icon: _this.icon };
            }
            _this.addMapLayers();
        };
    }
    TxSimpleMapComponent.prototype.ngAfterViewInit = function () {
        this.getMapContainer();
    };
    Object.defineProperty(TxSimpleMapComponent.prototype, "coordinate", {
        get: function () {
            return this._coordinate;
        },
        set: function (coordinate) {
            this.handleCoordinateInput(coordinate);
        },
        enumerable: true,
        configurable: true
    });
    TxSimpleMapComponent.prototype.ngOnInit = function () {
    };
    TxSimpleMapComponent.prototype.handleCoordinateInput = function (coordinate) {
        this.setLocationData(coordinate);
        if (this.mapContainer) {
            this.plotMap();
            this.updateMapView();
        }
    };
    TxSimpleMapComponent.prototype.setLocationData = function (coordinate) {
        if (coordinate) {
            this._coordinate = coordinate;
            this.lat = coordinate.latitude;
            this.lng = coordinate.longitude;
        }
    };
    TxSimpleMapComponent.prototype.plotMap = function () {
        this.handleMapInit();
    };
    TxSimpleMapComponent.prototype.handleMapInit = function () {
        if (!this.icon) {
            System.import('../../../../assets/marker-icon.png').then(this.setMapMarker);
        }
        else {
            this.setMapMarker(this.icon);
        }
    };
    TxSimpleMapComponent.prototype.addMapLayers = function () {
        if (!this.map) {
            this.createMap();
            this.createMapTileLayer();
        }
        if (this._coordinate) {
            this.updateMapView();
            this.addLocation();
        }
    };
    TxSimpleMapComponent.prototype.createMap = function () {
        this.map = L.map(this.mapContainer, {
            center: [this.lat, this.lng],
            zoom: this.zoom,
            worldCopyJump: true,
            closePopupOnClick: false,
            attributionControl: false
        });
    };
    TxSimpleMapComponent.prototype.createMapTileLayer = function () {
        L.tileLayer(this.MAP_URL, {
            accessToken: this.accessToken,
            attribution: this.attribution,
            maxZoom: 18,
            minZoom: 3,
            id: this.id
        }).addTo(this.map);
    };
    TxSimpleMapComponent.prototype.updateMapView = function () {
        if (this.map) {
            this.map.setView([this.lat, this.lng], this.zoom);
        }
    };
    TxSimpleMapComponent.prototype.addLocation = function () {
        if (this.map && this._coordinate) {
            if (this.marker) {
                this.map.removeLayer(this.marker);
            }
            this.marker = L.marker([this.lat, this.lng], this.options).addTo(this.map);
        }
    };
    TxSimpleMapComponent.prototype.getMapContainer = function () {
        var div = this.elRef.nativeElement.querySelector("#" + this.mapId);
        this.mapContainer = div;
        if (this.mapContainer) {
            this.handleCoordinateInput(null);
        }
    };
    TxSimpleMapComponent.ctorParameters = function () { return [{ type: core_1.ElementRef }]; };
    return TxSimpleMapComponent;
}());
exports.TxSimpleMapComponent = TxSimpleMapComponent;
//# sourceMappingURL=tx-simple-map.component.js.map


// WEBPACK FOOTER //
// tx-simple-map.component.js